/* eslint-disable react/prop-types */
import { h } from 'preact';
import Addon from './Addon';

const AddonList = ({ options, dispatch }) => {
  return (
    <div className="curbside_options">
      {options.map((opt) => (
        <Addon key={opt.id} option={opt} dispatch={dispatch} />
      ))}
    </div>
  );
};

export default AddonList;
